(function(){"use strict";}());

angular.module("app")
    .directive("artifactCollectionView", ["AppService","$timeout", function(AppService,$timeout){

        return {
            restrict: "A",
            replace: false,
            templateUrl: "views/artifact-collection.html",
            link: function($scope, element, attributes){
            	var trace = angular.trace;

            	$scope.$watch("currentPageIndex",onPeriodsSelect);

            	$scope.getArtifactPath = function(id){
            		return AppService.artifacts[id].target;
            	};

                $scope.getArtifactClass = function(id){
                    return AppService.artifacts[id].complete ? "active":null;
                };

                $scope.getArtifact = function(id){
                    return AppService.artifacts[id];
                };

            	function initialize(){
            		element.find(".droppable").droppable();
            	}
            	function onPeriodsSelect(value){
            		if(!value || value !== $scope.PAGE_ARTIFACT_COLLECTION) return;
            		element.find(".droppable").droppable({
            			accept:function(d){
            				return $(this).data("period") === d.data("period");
            			},
            			drop: function(e,d){
            				var img = d.draggable;
                            var artifact = $scope.getArtifact(img.data("target"));
                            $scope.$apply(function(){
                                artifact.complete = true;
                                $scope.pendingArtifact.pop();
                            });

            				d.draggable.fadeOut();
                            $scope.artifactPositioned();

            			}
            		});
            		element.find(".draggable").draggable({
            			revert:'invalid',
                        start:function(){
                            $scope.$apply(function(){
                                $scope.setDragging(true);
                            });
                        },
                        stop:function(){
                            $scope.$apply(function(){
                                $scope.setDragging(false);
                            });
                        }
            		});
            	}
            }
        };

    }]);
